import type { SVGProps } from 'react';

type GuidanceMarkProps = SVGProps<SVGSVGElement>;

/**
 * A route beacon: the central waypoint is surrounded by a safe path and
 * small orientation marks. Kept repo-native so it remains crisp in every
 * theme, density, and responsive context.
 */
export function GuidanceMark({ className, ...props }: GuidanceMarkProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
      {...props}
    >
      <circle cx="12" cy="12" r="7.25" opacity=".35" />
      <path d="M12 2.75v2M12 19.25v2M2.75 12h2M19.25 12h2" opacity=".55" />
      <path d="m14.75 8.25-1.42 5.08-5.08 1.42 1.42-5.08 5.08-1.42Z" />
      <circle cx="12" cy="12" r="1.35" fill="currentColor" stroke="none" />
      <path
        d="m17.65 4.8.38 1.03 1.02.37-1.02.38-.38 1.02-.37-1.02-1.03-.38 1.03-.37.37-1.03Z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
